import React from 'react'
import { css } from 'styled-components'
import {
  ArrowDownward as BaseArrowDownward,
  ErrorOutline,
  ExpandMore,
  Notifications,
  Search
} from '@mui/icons-material'
import {
  Accordion as AccordionBase,
  AccordionDetails as AccordionDetailsBase,
  AccordionSummary as AccordionSummaryBase,
  Divider as DividerBase,
  Grid as BaseGrid,
  styled
} from '@mui/material'
import {
  Button as ButtonBase,
  Card as CardBase,
  CheckBox as BaseCheckBox,
  Tag as TagBase
} from '@chilecompra/react-kit/components'

export const AddAlertIcon = styled(({ color, ...props }) => <Notifications {...props} />)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.blue[50]};
    font-size: 18px;
  }

  &.MuiSvgIcon-root:hover {
    fill: ${props => props.theme.palette.blue[35]};
  }
`

export const Accordion = styled(AccordionBase)``

export const AccordionSummary = styled(AccordionSummaryBase)`
  &.MuiAccordionSummary-root {
    padding: 0;
  }
`

export const AccordionDetails = styled(AccordionDetailsBase)`
  &.MuiAccordionDetails-root {
    display: flex;
    flex-direction: column;
    padding: 0;
  }
`

export const AlertIcon = styled(ErrorOutline)`
  color: ${props => props.theme.palette.red[50]};
`

export const Card = styled(CardBase)`
  &:hover {
    background-color: ${props => props.theme.palette.gray[95]};
  }
`

export const CheckBox = styled(BaseCheckBox)`
  &.MuiFormControlLabel-root .MuiFormControlLabel-label {
    color: ${props => props.theme.palette.gray[50]};
    font-size: 14px;
    margin: 3px 0 0;
  }
`

export const DateBox = styled('div')`
  text-align: ${props => props.textAlign};
  ${props => props.theme.breakpoints.up('sm')} {
    margin: auto;
    text-align: right;
  }
`

export const Divider = styled(DividerBase)`
  width: 100%;
`

export const ExpandMoreIcon = styled(ExpandMore)``

export const Grid = styled(({ textAlign, ...props }) => <BaseGrid {...props} />)`
  margin: ${props => props.margin};
  padding: ${props => props.padding};
  text-align: ${props => props.textAlign || 'initial'};
  width: 100%;
`

export const HeadingFiltersForm = styled('form')`
  background-color: ${props => props.theme.palette.brand.gray3};
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  grid-area: heading-filters;
  padding: 24px;
  width: 100%;

  ${props => props.theme.breakpoints.down('xs')} {
    flex-direction: column;
    padding: 12px;
  }
`

export const IconArrowDownward = styled(BaseArrowDownward)`
  color: ${props => props.theme.palette.brand.black3};
  margin: ${props => props.margin};
  font-size: 20px;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.blue[50]};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-weight: bold;
  line-height: 18px;
  margin: ${props => props.margin};
`

export const NotFoundImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: auto;
  width: 82px;
`

export const NotificationNumber = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.red[50]};
  border-radius: 12px;
  display: flex;
  justify-content: center;
  height: auto;
  min-height: 17px;
  min-width: 17px;
  top: -3px;
  right: -3px;
  position: absolute;
  width: auto;
`

export const NotificationSpan = styled('span')`
  color: ${props => props.theme.palette.brand.white};
  font-size: 12px;
  padding: 1.5px;
`

export const NotificationWrapper = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.gray[85]};
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  height: 36px;
  justify-content: center;
  position: relative;
  margin: ${props => props.margin};
  width: 36px;

  &:hover {
    background-color: ${props => props.theme.palette.gray[75]};
  }
`

export const QuoteButton = styled(({ width, ...props }) => <ButtonBase {...props} />)`
  &.MuiButtonBase-root {
    width: 100%;
    margin-top: 10px;

    ${props => props.theme.breakpoints.up('sm')} {
      margin-top: 0;
      margin-left: 10px;
    }

    ${props => props.theme.breakpoints.up('md')} {
      width: 240px;
    }
  }
`

export const ResumeWrapper = styled('div')`
  grid-area: resume;
`

export const SecondaryFiltersWrapper = styled('div')`
  grid-area: filters;
`

export const ResultsWrapper = styled('div')`
  grid-area: results;

  ${props => props.theme.breakpoints.up('md')} {
    margin-left: 10px;
  }
`

export const SearchButton = styled(ButtonBase)`
  &.MuiButtonBase-root {
    width: 100%;

    ${props => props.theme.breakpoints.up('md')} {
      width: 240px;
    }

    ${props => props.theme.breakpoints.up('lg')} {
      width: 200px;
      margin-left: 20px;
    }
  }
`

export const SearchIcon = styled(Search)`
  color: ${({ color, theme }) => (color === 'blue' ? theme.palette.blue[50] : theme.palette.gray[100])};
  cursor: pointer;
  font-size: 14px;
  margin-right: 8px;
`

export const TextOverflow = styled('p')`
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  font-size: 16px;
  font-weight: bold;
  margin: 3px 0;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Wrapper = styled('div')`
  align-items: center;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`
export const Label = styled('div')`
  background-color: ${props => props.theme.palette.gray[90]};
  color: ${props => props.theme.palette.brand.black2};
  font-size: 10px;
  font-weight: bold;
  text-transform: none;
  padding: 10px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 5px;
  line-height: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  letter-spacing: 1.5px;
  line-height: 14px;
  width: 100%;
`
export const LabelM = styled('div')`
  background-color: ${props => props.theme.palette.gray[90]};
  color: ${props => props.theme.palette.brand.black2};
  font-size: 10px;
  font-weight: bold;
  text-transform: none;
  padding: 10px;
  border-radius: 4px;
  display: inline-block;
  margin-top: 8px;
  line-height: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  letter-spacing: 1.5px;
  line-height: 14px;
  width: 100%;
`
export const GridItem = styled(props => <BaseGrid item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
    width: ${props => props.width};
  }
`
export const Tag = styled(TagBase)`
  &.MuiPaper-root > span:first-child {
    width: 100%;
  }
`
export const GridContainer = styled(({ enableBorder, ...props }) => <BaseGrid container {...props} />)`
  &.MuiGrid-container {
    ${props =>
      !props.enableBorder
        ? ''
        : css`
            border: 1px solid rgba(46, 91, 255, 0.08);
            border-radius: 1px;
          `}
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const ProviderNotEmtImage = styled('img')`
  width: 200px;
  height: 200px;
`
